// Full-document render of the tempurpedic ProductRegistrationPage "thank you"
// (landing) state, shown after a successful submission (and via the admin
// "landing" preview / the puppeteer `--submitted` fixture). This is the
// submitted-state branch -- the same container + hero stream, with the
// thank-you rich text in place of the picker + form (rendered only when the
// page has thank_you_text).
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { PageSkeleton } from "../components/PageSkeleton";
import { Template as ProductCalloutBlock } from "./ProductCalloutBlockTemplate";

// Mutable reactivated props (not Immutable<>): this template composes
// PageSkeleton, which is typed with mutable reactivated props (see
// PageSkeleton).
type IProps = templates.ProductRegistrationPageLandingTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="container product-registration l-full-width">
                <StreamField
                    tagName={React.Fragment}
                    value={props.page.hero.value}
                    components={{
                        product_callout: (block) => (
                            <ProductCalloutBlock value={block.value} />
                        ),
                    }}
                />
                {props.thank_you_html && (
                    <div className="thank-you-text l-capped-width">
                        <div
                            className="rich-text"
                            dangerouslySetInnerHTML={{
                                __html: props.thank_you_html,
                            }}
                        />
                    </div>
                )}
            </div>
        </PageSkeleton>
    );
};
